<template>
  <v-form ref="frmAdMain" lazy-validation>
    <v-card>
      <v-card-text>
        <v-row>
          <v-col cols="12" md="12" sm="6">
            <NumberField :rules="[rules.required]" min="-15" max="15" label="Adjustment" v-model="adjustment" outlined step="0.5" />
          </v-col>
        </v-row>
      </v-card-text>
      <v-card-actions>
        <v-row class="ma-0">
          <v-col cols="12" md="12">
            <v-btn class="primary right" :loading="loading" :disabled="loading" @click="confirm"><v-icon>mdi-check</v-icon>Save</v-btn>
            <v-btn class="secondary right mr-5" :disabled="loading" @click="cancel"><v-icon>mdi-cancel</v-icon>Cancel</v-btn>
          </v-col>
        </v-row>
      </v-card-actions>
    </v-card>
  </v-form>
</template>
<script lang="ts">
import { defineComponent } from "vue";
import TimesheetService from "../../services/TimesheetService";

export default defineComponent({
  props: {
    id: {
      required: true,
      type: String,
    },
    ad: {
      required: true,
      type: Number,
    },
    isAdmin: {
      required: true,
      type: Boolean,
    },
  },
  data() {
    return {
      adjustment: 0,
      loading: false,
      rules: {
        required: (value: any) => !!value || "Required.",
      },
    };
  },
  methods: {
    cancel() {
      this.$emit("cancel");
    },
    async confirm() {
      const isValid = await (this.$refs.frmAdMain as any).validate();
      if (isValid.valid) {
        this.loading = true;
        TimesheetService.updateAdjustment(this.id, this.adjustment, this.isAdmin)
          .then(() => {
            this.$emit("saved", this.adjustment);
          })
          .catch((error) => {
            this.$emit("errorRaised", error.response.data);
            this.loading = false;
          })
          .finally(() => {
            this.loading = false;
          });
      }
    },
  },
  watch: {
    adjustment(newVal) {
      if (newVal < -15) {
        this.adjustment = -15;
      } else if (newVal > 15) {
        this.adjustment = 15;
      }
    },
  },
  async mounted() {
    this.adjustment = this.ad;
  },
});
</script>
<style lang="scss" scoped>
.primary {
  color: #000 !important;
}
</style>
